var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3;
var _react_refresh_temp_4;
_react_refresh_temp_4 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createSelector } from '@reduxjs/toolkit';
import { store, useAppDispatch, useAppSelector, } from '../../../store';
import { updateIsActiveChatPanel, updateIsActiveWhiteboard, } from '../../../store/slices/bottomIconsActivitySlice';
import sendAPIRequest from '../../../helpers/api/plugNmeetAPI';
import { ChangeVisibilityRes } from '../../../helpers/proto/plugnmeet_common_api_pb';
const isActiveWhiteboardSelector = createSelector(_react_refresh_temp_1 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.isActiveWhiteboard);
$RefreshReg$(_react_refresh_temp_1, "isActiveWhiteboardSelector$createSelector");
const isWhiteboardVisibleSelector = createSelector(_react_refresh_temp_2 = (state) => { var _a; return (_a = state.session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features.whiteboard_features; }, (whiteboard_features) => whiteboard_features === null || whiteboard_features === void 0 ? void 0 : whiteboard_features.visible);
$RefreshReg$(_react_refresh_temp_2, "isWhiteboardVisibleSelector$createSelector");
const WhiteboardIcon = () => {
    var _a, _b, _c, _d;
    _react_refresh_temp_4();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const showTooltip = store.getState().session.userDeviceType === 'desktop';
    const [iconCSS, setIconCSS] = useState('primaryColor');
    const [initiated, setInitiated] = useState(false);
    const isActiveWhiteboard = useAppSelector(isActiveWhiteboardSelector);
    const isVisible = useAppSelector(isWhiteboardVisibleSelector);
    const allowedWhiteboard = (_a = store.getState().session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features.whiteboard_features.allowed_whiteboard;
    const isAdmin = (_c = (_b = store.getState().session.currentUser) === null || _b === void 0 ? void 0 : _b.metadata) === null || _c === void 0 ? void 0 : _c.is_admin;
    const isRecorder = (_d = store.getState().session.currentUser) === null || _d === void 0 ? void 0 : _d.isRecorder;
    useEffect(() => {
        if (isActiveWhiteboard) {
            setIconCSS('secondaryColor');
            if (!isRecorder) {
                dispatch(updateIsActiveChatPanel(false));
            }
        }
        else {
            setIconCSS('primaryColor dark:text-darkText');
        }
    }, [dispatch, isActiveWhiteboard]);
    useEffect(() => {
        if (!allowedWhiteboard) {
            return;
        }
        if (isVisible) {
            dispatch(updateIsActiveWhiteboard(true));
        }
        else if (!isVisible) {
            dispatch(updateIsActiveWhiteboard(false));
        }
    }, [isVisible]);
    useEffect(() => {
        var _a, _b, _c;
        if (!isAdmin || isRecorder) {
            return;
        }
        const currentRoom = store.getState().session.currentRoom;
        if (!initiated &&
            ((_a = currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features.whiteboard_features.visible)) {
            setInitiated(true);
            return;
        }
        else if (!initiated) {
            setInitiated(true);
        }
        const sendRequest = async (body) => {
            await sendAPIRequest('changeVisibility', body.toBinary(), false, 'application/protobuf');
        };
        if (isActiveWhiteboard &&
            !((_b = currentRoom.metadata) === null || _b === void 0 ? void 0 : _b.room_features.whiteboard_features.visible)) {
            const body = new ChangeVisibilityRes({
                roomId: currentRoom.room_id,
                visibleWhiteBoard: true,
            });
            // wait little bit before change visibility
            setTimeout(() => {
                sendRequest(body);
            }, 500);
        }
        else if (!isActiveWhiteboard &&
            ((_c = currentRoom.metadata) === null || _c === void 0 ? void 0 : _c.room_features.whiteboard_features.visible)) {
            const body = new ChangeVisibilityRes({
                roomId: currentRoom.room_id,
                visibleWhiteBoard: false,
            });
            sendRequest(body);
        }
    }, [isActiveWhiteboard]);
    const text = () => {
        if (isActiveWhiteboard) {
            return t('footer.icons.hide-whiteboard');
        }
        else {
            return t('footer.icons.show-whiteboard');
        }
    };
    const toggleWhiteboard = async () => {
        const isActiveScreenShare = store.getState().bottomIconsActivity.isActiveScreenshare;
        if (isActiveScreenShare) {
            return;
        }
        dispatch(updateIsActiveWhiteboard(!isActiveWhiteboard));
    };
    const render = () => {
        return (_jsxs("div", { className: `whiteboard h-[35px] lg:h-[40px] w-[35px] lg:w-[40px] relative rounded-full bg-[#F2F2F2] dark:bg-darkSecondary2 hover:bg-[#ECF4FF] ltr:mr-3 lg:ltr:mr-6 rtl:ml-3 lg:rtl:ml-6 flex items-center justify-center cursor-pointer ${showTooltip ? 'has-tooltip' : ''}`, onClick: () => toggleWhiteboard(), children: [_jsx("span", { className: "tooltip", children: text() }), _jsx(_Fragment, { children: _jsx("i", { className: `pnm-whiteboard ${iconCSS} text-[14px] lg:text-[16px]` }) })] }));
    };
    return _jsx(_Fragment, { children: allowedWhiteboard ? render() : null });
};
_react_refresh_temp_3 = WhiteboardIcon;
$RefreshReg$(_react_refresh_temp_3, "WhiteboardIcon");
_react_refresh_temp_4(WhiteboardIcon, "ngwpXcxOt+3NYLsBZvfr8iXVEzo=", false, () => [useTranslation, useAppDispatch, useAppSelector, useAppSelector]);
export default WhiteboardIcon;
